import {Component, Input} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {FormlyFieldConfig, FormlyFormOptions} from '@ngx-formly/core';
import {Location} from '@angular/common';

@Component({
  selector: 'app-crud-edit',
  templateUrl: './crud-edit.component.html',
  styleUrls: ['./crud-edit.component.scss']
})
export class CrudEditComponent {

  @Input() form: UntypedFormGroup;
  @Input() fields: FormlyFieldConfig[];
  @Input() model: any;
  @Input() options: FormlyFormOptions;

  @Input() sectionTitle: string;
  @Input() buttonTitle: string;

  @Input() entityroot = '';

  @Input() onSubmit: () => any;
  @Input() onCancel: () => any;

  @Input() isReady = false;
  @Input() isSubmitting = false;

  constructor(
    protected location: Location
  ) {

  }

  goBack() {
    this.location.back();
  }

}
